/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable @typescript-eslint/no-unused-vars, no-restricted-syntax */

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as Types from '../../../types/definitions/vendor/graphql-schema.d';

const defaultOptions = {} as const;

export type GetClientStyleProfileQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetClientStyleProfileQuery = {
  __typename?: 'Query';
  client?: {
    __typename?: 'Client';
    id: string;
    businessLine: Types.BusinessLine;
    dynamicProductAd?: {
      __typename?: 'DynamicProductAd';
      id: string;
      grouping: Types.DynamicProductAdGrouping;
    } | null;
    capabilities: {
      __typename?: 'ClientCapabilities';
      hasCompletedStyleProfile: boolean;
    };
  } | null;
};

export const GetClientStyleProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getClientStyleProfile' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessLine' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dynamicProductAd' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grouping' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'capabilities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'hasCompletedStyleProfile',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetClientStyleProfileQuery__
 *
 * To run a query within a React component, call `useGetClientStyleProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientStyleProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientStyleProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientStyleProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetClientStyleProfileQuery,
    GetClientStyleProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<
    GetClientStyleProfileQuery,
    GetClientStyleProfileQueryVariables
  >(GetClientStyleProfileDocument, options);
}
export function useGetClientStyleProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientStyleProfileQuery,
    GetClientStyleProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<
    GetClientStyleProfileQuery,
    GetClientStyleProfileQueryVariables
  >(GetClientStyleProfileDocument, options);
}
export type GetClientStyleProfileQueryHookResult = ReturnType<
  typeof useGetClientStyleProfileQuery
>;
export type GetClientStyleProfileLazyQueryHookResult = ReturnType<
  typeof useGetClientStyleProfileLazyQuery
>;
export type GetClientStyleProfileQueryResult = Apollo.QueryResult<
  GetClientStyleProfileQuery,
  GetClientStyleProfileQueryVariables
>;
